import { writable, readable } from 'svelte/store'

const info = writable({ window: {}, screen: {} })

export const now = readable(new Date(), (set) => {
    const interval = setInterval(() => {
        set(new Date())
    }, 1000)
    return () => {
        clearInterval(interval)
    }
})

export const getNow = (frec=1000) => readable(new Date(), (set) => {
    const interval = setInterval(() => {
        set(new Date())
    }, frec)
    return () => {
        clearInterval(interval)
    }
})


export default info
